import TextEntryQuizDisplay from './TextEntryQuizDisplay';

export default TextEntryQuizDisplay;
